import { useState, type FormEvent } from 'react';
import { Button } from '../components/Button';
import { Callout } from '../components/Callout';
import { TextField } from '../components/TextField';
import { apiAuth, ApiError } from '../lib/apiAuth';
import { useAdminEventoData } from './AdminEventoDataProvider';

interface Resp {
  token: string;
  aforo: { disponible: number };
  advertencia: string | null;
}

export function AltaPuertaScreen() {
  const { eventoId } = useAdminEventoData();
  const [nombre, setNombre] = useState('');
  const [acompanante, setAcompanante] = useState('');
  const [telefono, setTelefono] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [msg, setMsg] = useState<{ tono: 'exito' | 'alerta' | 'error'; texto: string } | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setMsg(null);
    setEnviando(true);
    try {
      const r = await apiAuth<Resp>(`/admin/eventos/${eventoId}/alta-puerta`, {
        method: 'POST',
        body: JSON.stringify({
          nombre,
          acompanante: acompanante.trim() || null,
          telefono,
        }),
      });
      setMsg({
        tono: r.advertencia ? 'alerta' : 'exito',
        texto: `${nombre} registrado en la puerta. ` + (r.advertencia ?? `Disponible: ${r.aforo.disponible}.`),
      });
      setNombre('');
      setAcompanante('');
      setTelefono('');
    } catch (err) {
      setMsg({
        tono: 'error',
        texto: err instanceof ApiError ? err.message : 'No se pudo registrar',
      });
    } finally {
      setEnviando(false);
    }
  }

  return (
    <form className="flex max-w-md flex-col gap-4" onSubmit={onSubmit}>
      <Callout tono="info">
        Solo un administrador puede hacer esto. Queda registrado con la hora y quién lo autorizó,
        y se reporta aparte en el resumen del evento.
      </Callout>

      <TextField label="Nombre completo" value={nombre} onChange={(e) => setNombre(e.target.value)} required />
      <TextField
        label="Acompañante"
        value={acompanante}
        onChange={(e) => setAcompanante(e.target.value)}
        hint="Deja vacío si viene solo"
      />
      <TextField
        label="Teléfono"
        type="tel"
        inputMode="tel"
        value={telefono}
        onChange={(e) => setTelefono(e.target.value)}
        required
      />

      {msg && <Callout tono={msg.tono}>{msg.texto}</Callout>}
      <Button type="submit" cargando={enviando}>
        Registrar entrada
      </Button>
    </form>
  );
}
